<template>
  <CModal
    :show.sync="this.show"
    :centered="true"
    add-content-classes="bgmodalmdl"
    :closeOnBackdrop="false"
  >
    <template #body-wrapper>
      <div class="modal-text">
        <div class="p-3 mt-3">
          <h1 class="ml-4 mt-3">SIGN UP</h1>
          <input
            v-model="otp"
            v-on:input="onChangeText(otp)"
            placeholder="Fill your verify code from your registered e-mail"
            type="Verify"
            class="underlineforgot ml-4 mt-3"
            style="
              padding-bottom: 0px;
              padding-top: 0px;
              padding-left: 0px;
              padding-right: 0px;
            "
          />
          <CButton @click="confirmOTP" class="btnforgot mt-3">Summit</CButton>
        </div>
      </div>
    </template>
    <template #header-wrapper>
      <div></div>
    </template>
    <template #footer-wrapper>
      <div></div>
    </template>
  </CModal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ModalVerifyOTP",
  props: {
    show: Boolean,
  },
  data() {
    return {
      otp: "",
    };
  },
  methods: {
    onChangeText(textHolder) {
      this.otp = textHolder;
    },
    confirmOTP() {
      let secretHolder = this.$store.getters.OTPSecretGetter;
      let payload = {
        token: this.otp,
        secret: secretHolder,
      };
      this.$store.dispatch("confirmOTPaction", payload);
    },
  },
  computed: {
    // used for detect data, in this project usually detect the response data from API
    // that collect in the getters of store (vuex)
    // bringing mapGetters to detect in getters of store (vuex)
    // syntax : ...mapGetters({ Name created variable for local data : Name of getters in store })
    // Example => ...mapGetters({ courses : 'courses/allCourses' })
  },
  watch: {
    // used to manage data after detect data
    // Syntax : Existing name of local variable : function(value){ Action }
    // Example => course : function(value){ this.data = value }
    // Value in parameter is the value of detected data changing
  },
  created() {
    // used for manage event when this page open
  },
  mounted() {
    // used for manage event when data has changed
  },
  beforeDestroy() {
    // used for update value before close this page
    // สมมติว่าจับเวลาใช้ในหน้านี้กี่นาที ให้มาเก็บในนี้
  },
};
</script>

<style scoped>
.bgmodalmdl {
  border-radius: 30px;
  width: 100%;
}
.underlineforgot {
  border: 0;
  outline: 0;
  background: transparent;
  width: 90%;
  border-bottom: 0.5px solid #cccccc;
}
.btnforgot {
  display: block;
  background-color: #0080ff;
  width: 173px;
  border-radius: 30px;
  padding-left: auto;
  color: white;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  text-align: center;
  margin: 0 auto;
}
.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: black;
  text-align: left;
}
</style>